module.exports = __webpack_public_path__ + "img/BannerMob-Quanta-Bank-03.b38faa7e.jpg";